import {useSelector} from 'react-redux';

import deviceSettingTypes from '../../../consts/device/deviceSettingTypes';
import getFeatureTypes from '../../../enums/app/getFeatureTypes';
import {makeSelectGetFeature, selectIsAnyGetFeature} from '../../../state/selectors/iotDevice';

const settinTypeGetFeatureMapping = {
    [deviceSettingTypes.AEM_FLEX_BATTERY]: getFeatureTypes.AEM_FLEX_BATTERY,
    [deviceSettingTypes.AEM_PAUSE_MODE]: getFeatureTypes.AEM_FLEX_BATTERY,
    [deviceSettingTypes.FLEX_PUFF]: getFeatureTypes.FLEX_PUFF,
    [deviceSettingTypes.AUTO_START_MODE]: getFeatureTypes.AUTOSTART,
    [deviceSettingTypes.CLEANING_MODE]: getFeatureTypes.CLEANING,
    [deviceSettingTypes.CONNECT_CARE]: getFeatureTypes.DIAGNOSTIC,
    [deviceSettingTypes.DEVICE_ADVANCED_DIAGNOSTIC]: getFeatureTypes.ADVANCED_DIAGNOSTIC,
    [deviceSettingTypes.EXTENDED_LED_SETTING]: getFeatureTypes.EXTENDED_LED,
    [deviceSettingTypes.GESTURE_MODE]: getFeatureTypes.GESTURE,
    [deviceSettingTypes.LED_SETTING]: getFeatureTypes.LED,
    [deviceSettingTypes.LOCATE_MY_DEVICE]: getFeatureTypes.LOCATE_MY_DEVICE,
    [deviceSettingTypes.RESPONSIVE_DRAW]: getFeatureTypes.RESPONSIVE_DRAW,
    [deviceSettingTypes.RESTART]: getFeatureTypes.DEVICE_RESET,
    [deviceSettingTypes.VAPE_CLOUD_SIZE]: getFeatureTypes.VAPE_CLOUD_SIZE,
    [deviceSettingTypes.VAPE_SESSION]: getFeatureTypes.VAPE_SESSION,
    [deviceSettingTypes.VIBRATION_MODE]: getFeatureTypes.VIBRATION,
    [deviceSettingTypes.DEVICE_RENAME]: getFeatureTypes.DEVICE_RENAME,
    [deviceSettingTypes.ABOUT_MY_DEVICE]: getFeatureTypes.ABOUT_MY_DEVICE,
};

const useIsGetFeatureAvailable = (settingType) => {
    const isAnyGetFeature = useSelector(selectIsAnyGetFeature);
    const featureType = settinTypeGetFeatureMapping[settingType];
    const getFeature = useSelector(makeSelectGetFeature(featureType));
    const isGetFeatureAvailable = !!getFeature?.length;

    return isAnyGetFeature && isGetFeatureAvailable ? featureType : false;
};

export default useIsGetFeatureAvailable;
